module.exports = __webpack_public_path__ + "img/competencies_swiper_04.8e2cb4d8.jpg";